import { call, put, takeLatest } from 'redux-saga/effects';
import { apiClient } from '../../../../api/client';
import { homeActions } from './index';

function* fetchStatus() {
  try {
    const { data } = yield call(apiClient.get, '/api/status');
    yield put(homeActions.fetchStatusSuccess(data.message || 'The Sports Hub API is running'));
  } catch {
    yield put(homeActions.fetchStatusFailure());
  }
}

function* fetchCourtSettings() {
  try {
    const { data } = yield call(apiClient.get, '/api/court-settings');
    yield put(homeActions.fetchCourtSettingsSuccess(data.courtSettings));
  } catch {
    yield put(homeActions.fetchCourtSettingsFailure());
  }
}

function* fetchVenueShowcase() {
  try {
    const { data } = yield call(apiClient.get, '/api/venue-showcase');
    yield put(homeActions.fetchVenueShowcaseSuccess(data.items));
  } catch {
    yield put(homeActions.fetchVenueShowcaseFailure());
  }
}

export function* homeSaga() {
  yield takeLatest(homeActions.fetchStatusRequest.type, fetchStatus);
  yield takeLatest(homeActions.fetchCourtSettingsRequest.type, fetchCourtSettings);
  yield takeLatest(homeActions.fetchVenueShowcaseRequest.type, fetchVenueShowcase);
}
